/*eslint-disable*/
import React from "react";
import "../components/footer.css";
import { Row, Col, Layout, Typography, Image, Input, Button } from "antd";
import fb from "../assets/images/fb.svg";
import instagram from "../assets/images/instagram.svg";
import place from "../assets/images/place.svg";
import email from "../assets/images/email.svg";
import call from "../assets/images/call.svg";
import logo from "../assets/images/logo.svg";
import vastu_logo from "../assets/images/vastu_logo.jpeg";
import { useHistory, useLocation } from "react-router-dom";
import { useBreakpoints } from "./ResponsiveBreakPoints";

const HomeFooter = () => {
  const location = useLocation();
  const history = useHistory();
  const { isSuperLarge, IsXS } = useBreakpoints();
  const scrollToSection = (section) => {
    if (location.pathname === "/") {
      const sectionElement = document.getElementById(section);
      if (sectionElement) {
        sectionElement.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      history.push("/");
      setTimeout(() => {
        const sectionId = section.replace("/", "");
        document
          .getElementById(sectionId)
          ?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  };

  const popularSearches = [
    "Commercial",
    "Residential",
    "Resale",
    "Rental",
    "Preleased",
    "Land/Plot",
  ];

  return (
    <>
      <Row justify="center" className="footerContainer">
        <Col
          xs={22}
          sm={22}
          md={22}
          lg={18}
          xl={20}
          xxl={16}
          style={{ maxWidth: isSuperLarge ? "50%" : "100%" }}
        >
          <Row gutter={[40, 50]} justify="center">
            {/* LEFT WHITE CARD */}
            <Col lg={12} md={12} sm={14} xs={24}>
              <div className="footerLogoContainer">
                <Row align="middle" justify="space-between" gutter={[12, 12]}>
                  {/* LEFT */}
                  <Col xs={20} sm={18}>
                    <div className="footerHeaderLeft">
                      <div className="footerLogoWrapper">
                        <img
                          src={vastu_logo}
                          alt="logo"
                          className="footerLogo"
                          onClick={() => history.push("/")}
                        />
                      </div>

                      <Typography className="footerCompanyName">
                        Shree Vastu Management & Developers
                      </Typography>
                    </div>
                  </Col>

                  {/* RIGHT */}
                  <Col xs={4} sm={6}>
                    <div className="footerHeaderRight">
                      <img
                        src={instagram}
                        alt="instagram"
                        onClick={() =>
                          window.open(
                            "https://www.instagram.com/shree_vastu_management/"
                          )
                        }
                      />
                      <img
                        src={fb}
                        alt="facebook"
                        onClick={() =>
                          window.open("https://facebook.com/svmdproperty/")
                        }
                      />
                    </div>
                  </Col>
                </Row>

                <div className="footerDivider" />

                <div className="footerContactItem" style={{ marginBottom: 8 }}>
                  <img src={place} alt="location" />
                  <span>
                    121/1, 4th Floor, Left Wing, Nalanda Complex, Near Mansi
                    Circle, Vastrapur, Ahmedabad-380015
                  </span>
                </div>

                <div className="footerContactItem" style={{ marginBottom: 8 }}>
                  <img src={email} alt="email" />
                  <a href="mailto:info@shreevastuproperties.com" style={{ color: 'inherit' }}>
                    <span>info@shreevastuproperties.com</span>
                  </a>
                </div>

                <div className="footerContactItem">
                  <img src={call} alt="call" />
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <a href="tel:+919909973307" style={{ color: 'inherit' }}>
                      <span>+91 99099 73307</span>
                    </a>
                    <a href="tel:+919909974407" style={{ color: 'inherit' }}>
                      <span>+91 99099 74407</span>
                    </a>
                  </div>
                </div>
              </div>
            </Col>

            {/* RIGHT LINKS */}
            <Col
              lg={12}
              md={12}
              sm={10}
              xs={24}
              className="menuContainer"
              style={{ textAlign: IsXS ? "center" : "start" }}
            >
              <Row gutter={[0, 30]}>
                {/* Company */}
                <Col xs={24} sm={12}>
                  <Row gutter={[0, 10]} style={{ flexDirection: "column" }}>
                    <Col>
                      <Typography className="mainTitle">Company</Typography>
                    </Col>
                    <Col>
                      <Typography
                        className="links"
                        onClick={() => scrollToSection("aboutus")}
                      >
                        About us
                      </Typography>
                    </Col>
                    <Col>
                      <Typography className="links">Contact us</Typography>
                    </Col>
                    <Col>
                      <Typography
                        className="links"
                        onClick={() => scrollToSection("service")}
                      >
                        Property service
                      </Typography>
                    </Col>
                  </Row>
                </Col>

                {/* Services */}
                <Col xs={24} sm={12}>
                  <Row gutter={[0, 10]} style={{ flexDirection: "column" }}>
                    <Col>
                      <Typography className="mainTitle">
                        Our Services
                      </Typography>
                    </Col>
                    {popularSearches.map((item, i) => (
                      <Col key={i}>
                        <Typography className="searches">{item}</Typography>
                      </Col>
                    ))}
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row className="copyright" justify="center">
        <Col xs={22} sm={22} md={22} lg={18} xl={20} xxl={16}>
          <Typography
            className="propertyServices"
            style={{ textAlign: "center" }}
          >
            Copyright © 2025 Shree Vastu Management and Developers. All Rights
            Reserved.
          </Typography>
        </Col>
      </Row>
    </>
  );
};
export default HomeFooter;
